import { CustomerAddress, customerAddressResource } from "./CustomerAddress";
import { RevisionMetadata } from "../RevisionItem";
import { Route, routeResource } from "./Route";

export const revisionMetadata: { [name: string]: RevisionMetadata } = {
  customerAddress: {
    resource: customerAddressResource,
    constructor: CustomerAddress,
  },
  route: {
    resource: routeResource,
    constructor: Route,
  },
};
